import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { Cms } from '@impact/data';
import { Environment, ENVIRONMENT } from '../../environment/environment';
import { SidePanelService } from '../../side-panel/side-panel.service';
import { resolveMediaUrl } from '../../utils/helpers/media-helpers';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-new-cars-model-card',
    templateUrl: './new-cars-model-card.component.html',
})
export class NewCarsModelCardComponent implements OnInit, OnChanges {
    @Input() data: Cms.VehicleCardDto;
    @Input() isInSlider = false;

    imageSrc: string;
    isLeasingSite = this.environment.site === 'Leasing';

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private sidepanelService: SidePanelService,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {}

    ngOnInit() {
        this.updateImageSrc();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data) {
            this.updateImageSrc();
        }
    }

    private updateImageSrc() {
        if (!this.data?.image) return;

        this.imageSrc = resolveMediaUrl(
            this.data?.image?.src,
            this.environment,
            { width: 400, format: 'webp' }
        );

        this.changeDetectorRef.detectChanges();
    }

    showLoanSimulator(price: number): void {
        if (price) {
            this.sidepanelService.showLoanCalculatorSidePanel({
                objectPrice: price,
            });
        }
    }
}
